export const calculateHeightDependingElement = (
  minHeightElemenThatdepends: number,
  maxHeightElemenThatdepends: number,
  minHeightElementWhichDepend: number,
  maxHeightElementWhichDepend: number,
  currentHeightElementWhichDepend: number
): number => {
  const rangeElementWhichDepend =
    maxHeightElementWhichDepend - minHeightElementWhichDepend
  const rangeElemenThatdepends =
    maxHeightElemenThatdepends - minHeightElemenThatdepends

  const divHeight =
    ((currentHeightElementWhichDepend - minHeightElementWhichDepend) *
      rangeElemenThatdepends) /
      rangeElementWhichDepend +
    minHeightElemenThatdepends

  return divHeight
}
